import { wrapSvg } from '../../../common/util/SvgImage';

export const MobileBackgroundElement = wrapSvg(
  <svg
    width="374"
    height="321"
    viewBox="0 0 374 321"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="346.717"
      height="2404.25"
      rx="173.358"
      transform="matrix(0.736438 -0.676506 -0.676506 -0.736438 210.491 392.139)"
      fill="#73E1E1"
    />
  </svg>,
);
